<template>
  <header class="site-header">
    <NavMenu />
    <MusicPlayer />
  </header>
</template>

<script>
import NavMenu from './NavMenu.vue';
import MusicPlayer from './MusicPlayer.vue';

export default {
  name: 'AppHeader',
  components: {
    NavMenu,
    MusicPlayer,
  },
};
</script>

<style scoped>
.site-header {
  height: 15vh;
  min-height: 15vh;
  max-height: 15vh;
  flex-shrink: 0;
}
</style>
